import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel
} from '@mui/material'
import { useCallback, useContext, useState } from 'react'

import { CenteredLoading } from '../../CenteredLoading/CenteredLoading'
import { AiHighlightsContainer } from './AiHighLightsContainer'
import { MaintenanceScheduleAccordion } from './MaintenanceScheduleAccordion'
import {
  MaintenanceScheduleContext,
  SeverityType
} from './MaintenanceScheduleProvider'
import { SearchByInterval } from './SearchByInterval'
import { useSubmitMaintenanceSchedule } from './useSubmitMaintenanceSchedule'

const MaintenanceScheduleDialog = ({
  handleClose
}: {
  handleClose: () => void
}) => {
  const {
    selected,
    maintenanceTimeline,
    severityType,
    loadingSchedule,
    loadingTimeline
  } = useContext(MaintenanceScheduleContext)
  const [isLoading, setIsLoading] = useState(false)

  const [addAsOne, setAddAsOne] = useState(false)

  const { submitMaintenanceSchedules } = useSubmitMaintenanceSchedule()

  const addMaintenanceSchedules = useCallback(async () => {
    if (selected.length === 0) {
      return
    }
    setIsLoading(true)
    const expandedLaborApplications = []
    for (const application of selected) {
      const laborApplication = {
        ...application,
        allLabor: false,
        additionalLabor: 0,
        optionalWork: new Set<number>(),
        taxExempt: false,
        isMaintenanceSchedule: true
      }
      expandedLaborApplications.push(laborApplication)
    }
    await submitMaintenanceSchedules(expandedLaborApplications, addAsOne)
    setIsLoading(false)
    handleClose()
  }, [selected, submitMaintenanceSchedules, addAsOne, handleClose])

  return (
    <>
      <Dialog open={true} fullWidth={true} maxWidth={'lg'}>
        <DialogTitle>Maintenance Schedules</DialogTitle>
        <DialogContent>
          {loadingSchedule ? <CenteredLoading /> : <AiHighlightsContainer />}
          <SearchByInterval />
          {loadingTimeline ? (
            <CenteredLoading />
          ) : (
            <>
              {maintenanceTimeline?.timeline.intervalMaintenanceSchedules!.map(
                (intervalMaintenanceSchedule, i) => (
                  <MaintenanceScheduleAccordion
                    key={i}
                    title={
                      intervalMaintenanceSchedule.interval +
                      ' ' +
                      maintenanceTimeline.intervalType
                    }
                    maintenanceSchedules={intervalMaintenanceSchedule.maintenanceSchedules!.filter(
                      (m) =>
                        severityType === SeverityType.Severe
                          ? m.timingInfoList?.severeServiceDescription === 'Yes'
                          : m.timingInfoList?.severeServiceDescription === 'No'
                    )}
                  />
                )
              )}
              {maintenanceTimeline?.timeline.supplementaryMaintenanceSchedules!.map(
                (supplementaryMaintenanceSchedule, i) => (
                  <MaintenanceScheduleAccordion
                    key={i}
                    title={supplementaryMaintenanceSchedule.frequency || ''}
                    maintenanceSchedules={supplementaryMaintenanceSchedule.maintenanceSchedules!.filter(
                      (m) =>
                        severityType === SeverityType.Severe
                          ? m.timingInfoList?.severeServiceDescription === 'Yes'
                          : m.timingInfoList?.severeServiceDescription === 'No'
                    )}
                  />
                )
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <FormControlLabel
            label="Add all to one Service"
            labelPlacement="start"
            control={
              <Checkbox
                checked={addAsOne}
                onChange={(event) => setAddAsOne(event.target.checked)}
                disabled={isLoading}
              />
            }
            sx={{ marginRight: 4 }}
          />
          <Button
            size="small"
            onClick={() => handleClose()}
            disabled={isLoading}
            data-testid="cancelButton">
            Close
          </Button>
          <Button
            variant="contained"
            disabled={isLoading || !selected || selected.length === 0}
            onClick={addMaintenanceSchedules}>
            {isLoading ? 'Loading...' : 'Add To Repair Order'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MaintenanceScheduleDialog
